import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { useBenefitList } from '@/core/domain/operational/benefits/benefits.hooks';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Benefit } from '@/core/domain/operational/benefits/benefits.types';

interface Props {
  onChange(benefit: Benefit | undefined): void;
  disableBenefitIds: number[];
  disabled: boolean;
}

export default function AddCourtesyBenefitTable(props: Props) {
  const [selectSearch, setSelectSearch] = useState('');

  const search = useDebounce(selectSearch, 500);

  const benefitList = useBenefitList({ search });

  const benefits = flatInfiniteData(benefitList.data);

  const options =
    benefits.map<DefaultOptionType>((benefit) => {
      const disabled = props.disableBenefitIds.includes(benefit.id);

      return {
        disabled,
        value: benefit.id,
        label: (
          <div>
            <span style={{ display: 'block' }}>{benefit.name}</span>
            <span style={{ color: 'darkgray' }}>
              {disabled ? 'Benefício selecionado' : 'Disponível'}
            </span>
          </div>
        ),
      };
    }) || [];

  return (
    <Select
      options={options}
      loading={benefitList.isLoading}
      disabled={benefitList.isLoading || props.disabled}
      placeholder={
        benefitList.isLoading
          ? 'Carregando benefícios de cortesia...'
          : 'Selecionar benefício de cortesia'
      }
      style={{ width: '100%' }}
      value={null}
      showSearch
      searchValue={selectSearch}
      onSearch={setSelectSearch}
      onChange={(value) => {
        const benefit = benefits.find((item) => item.id === value);

        props.onChange(benefit);
      }}
    />
  );
}
